export enum DiversityType {
  NUMBER = 'number',
  SYMBOL = 'symbol',
  LOWERCASE = 'lowercase',
  UPPERCASE = 'uppercase',
}
